import { DataNode } from "antd/lib/tree"
import { KeyValueModel, ModelBase } from "./ModelBase"
import { DataNode as RcDataNode } from 'rc-tree-select/lib/interface'
import { IconType } from "antd/lib/notification"

export class ContoCorrenteModel {
    Id: string
    Descrizione: string
    Iban: string
    Disabled: boolean
    ContoType: string
    ContoList: Array<KeyValueModel>
}

export class ContiCorrentiModel extends ModelBase {
    ContiCorrenti: Array<ContoCorrenteModel>
}

// per Yapily
export class AccessoContoCorrenteModel {
    Id: string
    NomeConto: string
    Banca: string
    Iban: string
    Consenso: boolean
    DataScadenza: Date
    ConsentToken: string
    IsEmbeddedFlow?:boolean
}

export class AccessoContiCorrentiModel extends ModelBase {
    ContiCorrenti: Array<AccessoContoCorrenteModel>
}

export class CatDataNode implements DataNode {
    checkable?: boolean;
    children?: DataNode[];
    disabled?: boolean;
    disableCheckbox?: boolean;
    icon?: IconType;
    isLeaf?: boolean;
    key: string | number;
    title?: React.ReactNode;
    selectable?: boolean;
    switcherIcon?: IconType;
    /** Set style of TreeNode. This is not recommend if you don't have any force requirement */
    className?: string;
    style?: React.CSSProperties;
    Level:number
}

export class CategorieModel extends ModelBase {
    Categorie: Array<CatDataNode> // Popolare title, key e children
}

export class CategoriaModel extends ModelBase {
    Descrizione: string
    Parent: string
}

export class CategoriaEditModel extends CategoriaModel {
    Categorie: Array<RcDataNode> // Popolare title, value e children
}

export class AccessoCcModel extends ModelBase {

}